import { render, staticRenderFns } from "./approvalRecord.vue?vue&type=template&id=58f3acee&scoped=true&"
import script from "./approvalRecord.vue?vue&type=script&lang=js&"
export * from "./approvalRecord.vue?vue&type=script&lang=js&"
import style0 from "./approvalRecord.vue?vue&type=style&index=0&id=58f3acee&lang=less&scoped=true&"
import style1 from "./approvalRecord.vue?vue&type=style&index=1&id=58f3acee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f3acee",
  null
  
)

export default component.exports